// extracted by mini-css-extract-plugin
module.exports = {"audioList":"styles_audioList__3TQqu","audioTools":"styles_audioTools__9yCtA","addAudio":"styles_addAudio__35tkl","audioItem":"styles_audioItem__2owfh"};